<template>
<div :ref="cateobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增教程分类</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="catelist.length > 1 ? catelist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="clearAll">清空已填模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="addpetmodel">新增模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回版本管理</el-button>
        </div>
    </div>
    

    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in catelist" :key="index">
            <div class="TTL-form-submit-box-title">分类-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" 
                v-if="catelist.length > 1" 
                @click.stop="()=> {
                    catelist.splice(index,1);
                    SaveDataToBrowser();
                }"
            >删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">所属一级分类</label>
                    <wcselect 
                        :list="parentcatelist"
                        :option="{placeholder:'请选择一级分类',clearable:true,filterable:true,width:220,ischange:true}" 
                        @finish="(val)=> {
                            if(val.type=='change') catelist[index].pid=val.value
                        }"
                     />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">分类名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.name" placeholder="请输入账号名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>


</div>
</template>

<script>
import INTERFACE_MODEL_PLAT_VEDIO from '@/Interface/Platsetting/PlatVedio';
export default {
    components:{},
    data() {
        return {
            cateobj:'platformvideocateadd',
            browsername:'platformvideocate',
            addlimit: 10,                              //单次新增限制
            cateinfo:{name:'',pid:''},                 //分类信息
            catelist:[],                               //分类列表
            parentcatelist:[],                         //一级分类信息大全
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetParentCate(); //获取一级分类信息
            this.ParseDataFromBrowser(); //解析数据
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                
            } 
        },


        /** 提交数据 **/
        submitData() {
            //调整提交数据
            var data=[];
            for(var i=0;i<this.catelist.length;i++) data.push(this.catelist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs[this.cateobj];
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_PLAT_VEDIO.ADD_CATE({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
                this.GoBackPets(true);
            });
        },



        /** 清空当前数据 **/
        clearAll() {
            this.$confirm.confirm(
                '您是否确定要删除当前所有账号信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.resetParam();
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            }).catch(()=> {

            });
        },

        
        /** 新增品种模板信息 **/
        addpetmodel() {
            if(this.catelist.length >= this.addlimit) {
                this.$notice({title:'消息提示',message:'单次添加版本数量请最多不要超过'+this.addlimit+'个',type:'warning'});
                return false;
            }

            var info=this.GetCateInfo();
            this.catelist.push(info);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.catelist);
            localStorage.setItem(this.browsername,data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem(this.browsername);
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetParam() : this.catelist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'使用教程分类',labelentry:'PlatFormVideoCate',components:'PlatFormVideoCate',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        /** 重置加载数据 **/
        resetParam() {
            this.catelist=[];
            var info=this.GetCateInfo();
            this.catelist.push(info);
            this.SaveDataToBrowser();
        },

        /** 获取分类信息 **/
        GetCateInfo() {
            var info={};
            for(var i in this.cateinfo) info[i]=this.cateinfo[i];
            return info;
        },

        /** 获取一级分类信息大全 **/
        GetParentCate() {
            this.$method.GET_PLAT_VEDIO_CATE_PARENT(true).then((res) => {
                this.parentcatelist=res;
                console.log(res)
            });
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.TTL-form-submit-box-title {margin-bottom:40px;}
</style>